import axios from 'axios';
import authToken from './authToken';
import cfac22 from '../cfac22';

export function apiConsumeVoucher(uId, triiboId, storeId) {
  return new Promise(function (resolve, reject) {
    authToken(uId)
      .then((token) => {
        axios
          .post(
            cfac22('API_HOST_V2') + '/vouchers/consumeVoucher',
            {
              triiboId,
              storeId,
            },
            {
              headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
            }
          )
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      })
      .catch((errorToken) => {
        reject(errorToken);
      });
  });
}
